import React from "react";
import { useParams } from "react-router-dom";
import { HomeGamesData } from "../../helperFunction";
import { Carousel, Col, Row, Space } from "antd";
import androidImg from "../../assets/02_google.png";
import appleImg from "../../assets/01_apple.png";
import StoryVideo from "../ourStory/storyVideo";
import "./styles.scss";

const GameDetailPage = () => {
  const params = useParams();
  const gameId = params?.gameId;
  const gameData = HomeGamesData?.find((e) => e?.id === gameId);
  console.debug("game-data", gameData?.detailBannerImg);
  return (
    <section className="game-detail-page">
      <div className="game-detail-page-banner">
        <img
          className="game-detail-banner-img"
          src={gameData?.detailBannerImg?.[0]?.bannerImg}
          alt="#bannerimg"
        />
      </div>
      <div className="center-detail-section-content">
        <Row gutter={[24, 24]}>
          <Col
            xs={24}
            sm={12}
            md={12}
            lg={8}
            xl={8}
            xxl={8}
            className="left-image-link-col"
          >
            <img
              src={gameData?.gameImg}
              alt="#"
              className="small-game-detail-img"
            />
            <div>
              <a href={gameData?.appleLink} target="_blank">
                <img src={appleImg} className="detail-link-image" alt="#" />
              </a>
            </div>
            {gameData?.anroidLink ? (
              <div>
                <a
                  href={gameData.anroidLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={androidImg} alt="Android Link" />
                </a>
              </div>
            ) : (
              console.log(
                "androidLink is empty or undefined:",
                gameData?.anroidLink
              )
            )}
          </Col>
          <Col
            xs={24}
            sm={12}
            md={12}
            lg={8}
            xl={8}
            xxl={8}
            className="center-detail-text-col"
          >
            <div className="detail-heading-text">{gameData?.gameDesc}</div>
            <div className="detail-paragraph-text">{gameData?.detail}</div>
            <div className="detail-paragraph-text">{gameData?.detail1}</div>
            <div
              className="detail-paragraph-text"
              dangerouslySetInnerHTML={{ __html: gameData?.detail2 }}
            ></div>
          </Col>
          <Col
            xs={24}
            sm={12}
            md={12}
            lg={8}
            xl={8}
            xxl={8}
            className="right-detail-params-col"
          >
            <div className="detail-sub-heading-text">Details</div>
            <div className="param-text">Developer(s)</div>
            <div className="developers-all-text">
              {gameData?.developers?.map((e, index) => {
                return (
                  <Space key={index} direction="horizontal" align="center">
                    {e?.developer},
                  </Space>
                );
              })}
            </div>
            <div className="param-text">Publisher</div>
            <div className="developers-all-text">
              {gameData?.publisher?.map((e, index) => {
                return (
                  <Space key={index} direction="horizontal" align="center">
                    {e?.publisher}
                  </Space>
                );
              })}
            </div>
            <div className="param-text">Platform(s)</div>
            <div className="developers-all-text">
              {gameData?.platForms?.map((e, index) => {
                return (
                  <Space key={index} direction="horizontal" align="center">
                    {e?.platForm}
                  </Space>
                );
              })}
            </div>
            <div className="param-text">Game language</div>
            <div className="developers-all-text">
              {gameData?.gameLanguages?.map((e, index) => {
                return (
                  <Space key={index} direction="horizontal" align="center">
                    {e?.gameLanguage},
                  </Space>
                );
              })}
            </div>
            {/* <div className="param-text">Link</div> */}
            {/* <div className="developers-all-text">
              <a href={gameData?.gameWebsiteLink} target="_blank">
                Official website
              </a>
            </div> */}
          </Col>
        </Row>
      </div>
      {/* <div className="game-detail-carousel-images">
        <Carousel
          arrows
          autoplay={false}
          dots={true}
          className="game-banner-carousel"
        >
          {gameData?.sliderImages?.map((e, index) => {
            return (
              <div key={index} className="home-banner-container">
                <img src={e?.img} alt="#" className="game-detail-banner-img" />
              </div>
            );
          })}
        </Carousel>
      </div> */}
      {gameData?.gameVideoLink && (
        <div className="video-player-section">
          <StoryVideo videoLink={gameData?.gameVideoLink} />
        </div>
      )}
      {/* {gameData?.detailBannerImg.length > 1 && (
        <img
          className="game-detail-banner-img"
          src={gameData?.detailBannerImg?.[1]?.bannerImg}
          alt="#bannerimg"
        />
      )} */}

      {/* The followig section will only show up when there is a video on tha page */}
      {gameData?.videoLink && (
        <div className="download-options-section">
          <div className="download-now-text">Download now:</div>
          <section className="download-content-section">
            <div>
              <a href={gameData?.appleLink} target="_blank">
                <img src={appleImg} alt="#" />
              </a>
            </div>
            {gameData?.anroidLink ? (
              <div>
                <a
                  href={gameData.anroidLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={androidImg} alt="Android Link" />
                </a>
              </div>
            ) : (
              console.log(
                "androidLink is empty or undefined:",
                gameData?.anroidLink
              )
            )}
          </section>
        </div>
      )}
    </section>
  );
};

export default GameDetailPage;
